import React, { useState } from "react";
import { Container, Card, Form, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { useI18n } from "../i18n";

const PasswordResetRequest: React.FC = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const { t } = useI18n();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      await axios.post("/api/auth/password-reset-request", { email });
      setSuccess(true);
      setEmail("");
    } catch (err: any) {
      if (err.response?.status === 404) {
        setError(t("passwordReset.emailNotFound"));
      } else {
        setError(t("messages.passwordResetRequestError"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="py-5">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-5">
          <Card className="shadow">
            <Card.Body className="p-4">
              <h3 className="text-center mb-4">{t("passwordReset.title")}</h3>
              <p className="text-muted text-center mb-4">
                {t("passwordReset.description")}
              </p>

              {success && (
                <Alert variant="success">
                  <Alert.Heading>{t("passwordReset.successHeading")}</Alert.Heading>
                  <p>{t("passwordReset.requestSent")}</p>
                </Alert>
              )}

              {error && <Alert variant="danger">{error}</Alert>}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>{t("common.email")}</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    required
                  />
                  <Form.Text className="text-muted">
                    {t("passwordReset.emailHelp")}
                  </Form.Text>
                </Form.Group>

                <div className="d-grid gap-2">
                  <Button type="submit" variant="primary" disabled={loading}>
                    {loading ? t("common.sending") : t("passwordReset.sendButton")}
                  </Button>
                  <Link to="/login" className="btn btn-link">
                    {t("passwordReset.backToLogin")}
                  </Link>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </div>
    </Container>
  );
};

export default PasswordResetRequest;
